module.exports = __webpack_public_path__ + "img/left_md_4.21d8e56b.jpg";